import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { isMemoriesHost } from '../utils/memoriesHost';
import { redirectMemoriesToSharedLogin } from '../utils/memoriesAuthBridge';

const PrivateRoute = ({ children, travelerOnly = false }) => {
  const { user, loading, isTokenExpired } = useAuth();
  const location = useLocation();

  const partnerToken = localStorage.getItem('partnerToken');
  const partner = partnerToken ? JSON.parse(localStorage.getItem('partner') || '{}') : null;

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Authenticating...
        </Typography>
      </Box>
    );
  }

  if (!travelerOnly && partner && partnerToken) {
    if (isTokenExpired(partnerToken)) {
      localStorage.removeItem('partnerToken');
      localStorage.removeItem('partner');
      return <Navigate to="/partner/login" state={{ from: location }} replace />;
    }
    return children;
  }

  const token = localStorage.getItem('token');
  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (isMemoriesHost()) {
      redirectMemoriesToSharedLogin(
        `${window.location.origin}${location.pathname}${location.search || ''}`
      );
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress size={40} />
        </Box>
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Valid JWT still present — wait for AuthContext to finish hydrate/validate
  // instead of bouncing to login on a flaky mobile cold start.
  if (!user) {
    if (loading) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          gap={2}
        >
          <CircularProgress size={40} />
          <Typography variant="body2" color="text.secondary">
            Authenticating...
          </Typography>
        </Box>
      );
    }
    if (isMemoriesHost()) {
      redirectMemoriesToSharedLogin(
        `${window.location.origin}${location.pathname}${location.search || ''}`
      );
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress size={40} />
        </Box>
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
